import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SpinnerComponent } from '@sarasanalytics-com/design-system';
import { NgOtpInputComponent } from 'ng-otp-input';

@Component({
  selector: 'sa-otp',
  standalone: true,
  imports: [NgOtpInputComponent, SpinnerComponent, CommonModule],
  templateUrl: './otp.component.html',
  styleUrl: './otp.component.scss'
})
export class OtpComponent {
  @Output('onChange') onChange: EventEmitter<any> = new EventEmitter();
  @Input('showSpinner') showSpinner: boolean = true;
  @Input('errorMsg') errorMsg = '';
  @Input('status') status: null | 'success' | 'failure' = null;
  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput: NgOtpInputComponent;

  onOtpChange(value: any) {
    this.onChange.next(value);
    this.addSeparator()
  }
  
  ngAfterViewInit() {
    this.addSeparator()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showSpinner'] && !this.showSpinner) {
      this.addSeparator()
    }
  }

  private addSeparator() {
    try {
      setTimeout(() => {
        const inputs = document.querySelectorAll('.sa-otp-input');
        if (inputs.length >= 4) {
          if (!document.querySelector('.otp-separator')) {
            const separator = document.createElement('span');
            separator.innerText = '-';
            separator.classList.add('otp-separator', 'text', 'text-14');
            inputs[2].parentNode?.insertBefore(separator, inputs[3]);
          }
        }
      },0);
    } catch (error) {

    }
  }

  resetValue(){
    if(this.ngOtpInput){
      this.ngOtpInput.setValue('');
      const eleId = this.ngOtpInput.getBoxId(0);
      this.ngOtpInput.focusTo(eleId);
    }
  }
}
